export default "__VITE_ASSET__bdbb95fe__"